module.exports = __webpack_public_path__ + "static/media/leaflet.06101a09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/leaflet.jpg
// module id = 188
// module chunks = 0